import { createVanIconComponent } from "./van"

const HotelOutlined = createVanIconComponent("hotel-o")
export default HotelOutlined
